module.exports = __webpack_public_path__ + "a304a8c3d45ab69ac04d22f8c7bfdfbf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-17.png
// module id = 1170
// module chunks = 0